import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const useUserAuthLoginCheck = () => {
  const router = useRouter();
  /**
   * methods
   */
  const goToAuthLoginCheckPage = () => {
    router.replace(`/auth/login-check?redirectUrl=${router.asPath}`);
  };

  return {
    goToAuthLoginCheckPage,
  };
};
